import $ from 'jquery';

$.fn.isElementInside = function(element)  {
    "use strict";

    if (typeof element === "string") {
        element = $(element);
    }

    return !!this.closest(element).find(this).length || $(this).is(element);
};